import { QUESTIONS } from '../data/questions.js';

export function criterionScores(answers) {
  const sum = {};
  const cnt = {};

  QUESTIONS.forEach((q) => {
    sum[q.dim] = 0;
    cnt[q.dim] = 0;
  });

  QUESTIONS.forEach((q) => {
    const a = answers[q.id];
    if (a) {
      sum[q.dim] += a;
      cnt[q.dim] += 1;
    }
  });

  const out = {};
  Object.keys(sum).forEach((k) => {
    out[k] = cnt[k] ? sum[k] / cnt[k] : 0;
  });

  return out; // 1..5 per dimension
}
